import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ConfigurationComponent = () => {
  return (
    <>
      <Helmet>
        <title>Configuration | Admin</title>
      </Helmet>
      <Outlet />
    </>
  );
};

export default ConfigurationComponent;
